<template>
<footer class="footer">
    <div class="container-fluid">
        <div class="row text-xs-center">
            <div v-show="footer_logo" class="col-sm-3">
                <img :src="footer_logo" :alt="appTitle" class="logo">
            </div>
            <div v-show="footerText" class="col-md-9 text-sm-right">
                <p class="copy" v-html="footerText"></p>
            </div>
        </div>
    </div>
</footer>
</template>

<script>
// import name from 'name'

export default {
    name: 'Footer',
    data() {
        return {
            appTitle: window.APP_NAME,
            footerText: window.footerConfig.footer_text,
            footer_logo: window.footerConfig.footer_logo
        }
    }
}
</script>


// WEBPACK FOOTER //
// Footer.vue?d35e86cc